import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../settings/app-settings';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    constructor(
        readonly http: HttpClient,
        private router: Router,
    ) { }

    private apiUrl = AppSettings.API_ENDPOINT;

    getApiEndpoint(appSettings: AppSettings, action?: string): string {
        let retVal = `${this.apiUrl}${appSettings}`;
        if (action) {
            retVal = `${retVal}/${action}`;
        }
        return retVal;
    }
}
